import {RequestGroup} from './request-group';
import {RequestHystory} from './request-hystory';
import {RequestHistoryAudits, RequestUnifications} from './request-unifications';
import {User} from '../user/user';

export class Request {

    id: string;
    name: string;
    code: string;
    motive: string;
    channelDistribution: string;
    unitMeasure: string;
    description: string;
    recordHolder: string;
    ministryRecord: string;
    dispatchedBy: string;
    recordValidity: Date;
    manufacturer: string;
    dueDate: number;
    dueDateRevised: number;
    codeSap: string;
    descriptionFinish: string;
    country: string;
    status: string;
    step: number;
    type: string;
    bulk: boolean;
    ean: string;
    dum: string;
    unificationObservation: string;
    unifications: RequestUnifications[];
    createdAt: Date;
    updatedAt: Date;
    group: RequestGroup[];
    history: RequestHystory[];
    historyAudits: RequestHistoryAudits[];
    createdBy: User;
    countryNotification: string;
    countryNotifications: any[];
    countryAdditional: any[];
    reasonRequest: number;
    molecule: string;
    concentration: string;
    concentrationType: string;
    productBrand: string;
    productBrandType: string;
    commercialPresentation: string;
    stepReprove: number;
    area_400: string;
    countrySolicitationPmoInt: string;
    countryManufacturingPmoInt: string;

    flowType: string;
    centerModel: string;
    channelModel: string;
    reasonRequestInfo: string;
    typeMaterial: string;
    center: string;
    concentrationPrinciple1: string;
    concentrationPrinciple2: string;
    concentrationPrinciple3: string;
    concentrationPrinciple4: string;
    ncm: string;
    taxClassification: string;
    groupCtgs: string;
    materialGroup1: string;
    aprova: string;

    countrySolicitationGenfar: any[];
    countryManufacturingGenfar: string;

    countrySolicitationProductsLatam: string;
    countryManufacturingProductsLatam: string;

    dcb1: string;
    dcb2: string;
    dcb3: string;
    dcb4: string;
    anvisaClassification: string;
    productPresentation: string;
    therapyClass: string;
    applicationType: string;
    referenceMed: string;
    doseUnit: string;
    pharmForm: string;
    productStripe: string;
    storageCondition: string;
    storageTemperature: number;
    storageHumidity: number;
    expirationDate: number;
    originalProductPresentation: string;
    medicalPrescription: string;
    sectorOfActivity: string;
    productType: string;
    cst: number;
    originalCountry: string;
    priceReais: string;
    leadTime: number;

    AcronymCode: string;
    partnerName: string;
    netWeight: string;
    grossWeight: string;
    // expirationDate: number;
    euroAnalysis: string;
    // pharmForm: string;
    // storageCondition: string;
    productStatus: string;

    constructor() {
        this.group = [];
        this.history = [];
        this.unifications = [];
        this.countryNotifications = [];
        this.countryAdditional = [];
        this.countrySolicitationGenfar = [];
    }
}
